import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyTheme, readPreference } from './utils/theme';
import { applyChatPrefs, loadChatPrefs } from './utils/chatPrefs';
import './styles.css';

// Apply the saved theme preference before React renders so there's no
// flash-of-wrong-theme on initial paint.
applyTheme(readPreference());
// Same idea for chat-specific prefs (font size, wallpaper) — set the CSS
// custom properties before the first paint.
applyChatPrefs(loadChatPrefs());

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
